// Lib
import { compose, defaultProps } from '../../../../../node_module_clones/recompose';

// Components
import poiDecorator from '../../../pointsOfInterest/poiDecorator';

// Constants
import { PoiType } from '../../../pointsOfInterest/poiConstants';

export default compose(
    defaultProps({
        poiType: PoiType.search,
        poiData: {
            count: 1,
        },
    }),
    poiDecorator,
);
